// Fonte única dos destinos do link único do parceiro: o mesmo endereço abre o app
// (App Link no Android, Universal Link no iOS) quando ele está instalado e o painel
// web quando não está.
//
// Os caminhos estão espelhados em `public/.well-known/apple-app-site-association` e no
// repo bigou-pedidos-mobile (`env/index.js` e `app/lib/DeepLinkManager.js`). Mexeu em
// um, mexa nos três — ver docs/deeplink-app-parceiro.md.
//
// Consumido por: guard do router (guarda a rota antes de mandar pro login) e pelo
// APP_LOGIN_SUCCESS (event.js, devolve o parceiro ao destino depois de logar).

const CHAVE_ROTA_PRETENDIDA = 'bigou:rotaPretendida';

// Scheme próprio do app. Só abre o app; não tem fallback pra web.
export const APP_SCHEME = 'bigoupedidos';

export const DESTINOS_DEEPLINK = [
  { chave: 'marketing', titulo: 'Aba de Marketing', rota: '/delivery/marketing' },
  { chave: 'cupons', titulo: 'Aba de Cupons', rota: '/delivery/cupom-desconto' },
  { chave: 'promocoes', titulo: 'Aba de Promos', rota: '/delivery/marketing/campanhas' },
];

export const destinoDeeplink = (chave) => DESTINOS_DEEPLINK.find((d) => d.chave === chave) || null;

// Link que deve ser divulgado (push, e-mail, campanha): abre o app ou, sem app, o painel.
export const linkUnico = (chave, origem) => {
  const destino = destinoDeeplink(chave);
  if (!destino) return null;
  const base = (origem || window.location.origin || '').replace(/\/+$/, '');
  return `${base}${destino.rota}`;
};

// Link direto pro app, para quando já se sabe que ele está instalado.
export const linkApp = (chave) => {
  const destino = destinoDeeplink(chave);
  return destino ? `${APP_SCHEME}:/${destino.rota}` : null;
};

// Sessão expirada ou parceiro deslogado: o destino do link fica guardado até o login,
// senão o link único sempre desembocaria na home do painel.
export const guardarRotaPretendida = (rota) => {
  try {
    if (rota) window.sessionStorage.setItem(CHAVE_ROTA_PRETENDIDA, rota);
  } catch (error) {
    // Modo privado do Safari bloqueia o sessionStorage. Sem ele o login cai na home.
  }
};

export const consumirRotaPretendida = () => {
  try {
    const rota = window.sessionStorage.getItem(CHAVE_ROTA_PRETENDIDA);
    window.sessionStorage.removeItem(CHAVE_ROTA_PRETENDIDA);
    return rota || null;
  } catch (error) {
    return null;
  }
};
